export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const MENU_PERMISSION_GROUPS = [
  {
    groupKey: 'conversations',
    topLevel: null,
    permissions: [
      'menu_conversations_mentions',
      'menu_conversations_unattended',
      'menu_conversations_bot_queue',
      'menu_conversations_folders',
      'menu_conversations_teams',
      'menu_conversations_channels',
      'menu_conversations_labels',
    ],
  },
  {
    groupKey: 'captain',
    topLevel: 'menu_captain',
    permissions: [
      'menu_captain_responses',
      'menu_captain_documents',
      'menu_captain_scenarios',
      'menu_captain_playground',
      'menu_captain_inboxes',
      'menu_captain_tools',
      'menu_captain_settings',
    ],
  },
  {
    groupKey: 'contacts',
    topLevel: 'menu_contacts',
    permissions: [
      'menu_contacts_active',
      'menu_contacts_segments',
      'menu_contacts_labeled',
    ],
  },
  {
    groupKey: 'reports',
    topLevel: 'menu_reports',
    permissions: [
      'menu_reports_overview',
      'menu_reports_conversation',
      'menu_reports_agents',
      'menu_reports_labels',
      'menu_reports_inboxes',
      'menu_reports_teams',
      'menu_reports_csat',
      'menu_reports_sla',
      'menu_reports_bot',
      'menu_reports_user_status',
      'menu_reports_online_users',
      'menu_reports_user_login',
      'menu_reports_conversations',
    ],
  },
  {
    groupKey: 'dashboard',
    topLevel: 'menu_dashboard',
    permissions: [],
  },
  {
    groupKey: 'campaigns',
    topLevel: 'menu_campaigns',
    permissions: [
      'menu_campaigns_livechat',
      'menu_campaigns_sms',
      'menu_campaigns_whatsapp',
    ],
  },
  {
    groupKey: 'help_center',
    topLevel: 'menu_help_center',
    permissions: [
      'menu_help_center_articles',
      'menu_help_center_categories',
      'menu_help_center_locales',
      'menu_help_center_settings',
    ],
  },
  {
    groupKey: 'settings',
    topLevel: 'menu_settings',
    permissions: [
      'menu_settings_account',
      'menu_settings_notifications',
      'menu_settings_agents',
      'menu_settings_teams',
      'menu_settings_assignment',
      'menu_settings_inboxes',
      'menu_settings_labels',
      'menu_settings_attributes',
      'menu_settings_automation',
      'menu_settings_flow_builder',
      'menu_settings_bots',
      'menu_settings_macros',
      'menu_settings_canned',
      'menu_settings_templates',
      'menu_settings_antispam',
      'menu_settings_integrations',
      'menu_settings_audit_logs',
      'menu_settings_access_profiles',
      'menu_settings_sla',
      'menu_settings_workflow',
      'menu_settings_security',
    ],
  },
];

export const AVAILABLE_MENU_PERMISSIONS = MENU_PERMISSION_GROUPS.flatMap(g =>
  g.topLevel ? [g.topLevel, ...g.permissions] : g.permissions
);

export const ROLES = ['agent', 'administrator'];

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
  unassigned: {
    count: 'unAssignedCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  all: {
    count: 'allCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
};
